import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'
import 'firebase/analytics';
import 'firebase/storage';

var firebaseConfig = {
    apiKey: "AIzaSyCWMpxaZVpmkKHHUB4sc6lqLXR3_VV1Bfs",
    authDomain: "bound-cb3e2.firebaseapp.com",
    projectId: "bound-cb3e2",
    storageBucket: "bound-cb3e2.appspot.com",
    messagingSenderId: "1083286965001",
    appId: "1:1083286965001:web:0e748a8b50cd7a998f21d8",
    measurementId: "G-7ZJGP1VVMR"
  };
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);
  firebase.analytics();

  const storage = firebase.storage();
  const auth = firebase.auth();

  export { storage, auth, firebase as default };